import React from "react";

import TextInput from "components/shared/form/fields/TextInput";
import { map } from "lodash";
import Loading from "components/shared/Loading";
import TypeFields from "components/shared/form/fields/TypeFields";
import { Property } from "components/groups/types";

type BasicSettingsArgs = {
  isLoading: boolean;
  app?: {
    properties: Property[];
  };
};

export default function BasicSettings({ app, isLoading }: BasicSettingsArgs) {
  if (isLoading) return <Loading />;

  return (
    <div className="form-horizontal">
      <h3>{I18n.t("js.groups.edit.basic_settings")}</h3>
      <TextInput name="group_category_id" type="hidden" />
      <TextInput
        label={I18n.t("js.groups.form.name.label")}
        name="name"
        placeholder={I18n.t("groups.form.name.placeholder")}
        required
      />
      {map(app?.properties, (property) => (
        <TypeFields key={property._id} {...property} />
      ))}
    </div>
  );
}
